
import CatalogMiniature from "src/modules/catalog/components/cards/parts/CatalogMiniature.vue"
import ProgressIndicator from "src/modules/catalog/components/cards/indicators/ProgressIndicator.vue"
import ScoreIndicator from "src/modules/catalog/components/cards/indicators/ScoreIndicator.vue"
import Component from "vue-class-component";
import {Prop, Vue} from "vue-property-decorator";

@Component({
  components: {CatalogMiniature, ProgressIndicator, ScoreIndicator},
  })
export default class CatalogMiniatureWithInformation extends Vue {
  @Prop({required: true}) catalogEntryMixin!: any;
}
